export default {
      id: "ic_share-usage",
      viewBox: "0 0 16 18",
      url: "/" + "images/icons.3.109.2.svg#ic_share-usage",
      toString: function () {
        return this.url;
      }
    }